import { IThreeLeveledSectionProps } from "./ThreeLeveledSection";
import { Slider } from "../Slider";

export const View = (props: IThreeLeveledSectionProps) => {
  return (
    <div
      className={
        (props.hasBorder ? "has-border" + " " : "") +
        props.className +
        " " +
        "three-leveled-section"
      }
    >
      <div className="left-section">{props.titleLogo}</div>
      <div className="right-section">
        <div className="three-contents">
          <div className="title">{props.rightFirstItem}</div>
          <div>{props.rightSecondItem}</div>
          <div>{props.rightThirdItem}</div>
        </div>
        <div>
          <Slider
            onToggle={props.onToggle}
            checked={props.checked}
            isLoading={props.isLoading}
          />
        </div>
      </div>
    </div>
  );
};
